import axios from "axios";
import Config from "../utils/Config";

class SettingsService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }

  async changePassword(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/change/password`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Password changed successfully!",
        data: response.data,
      };
    } catch (error) {
      let errorMessage = "An error occurred while changing password";

      if (error.response) {
        if (error.response.status === 422) {
          if (error.response.data?.errors) {
            const errorFields = Object.keys(error.response.data.errors);
            if (errorFields.length === 1) {
              errorMessage = error.response.data.errors[errorFields[0]][0];
            } else {
              errorMessage = `${
                error.response.data.errors[errorFields[0]][0]
              } (and ${errorFields.length - 1} more error${
                errorFields.length > 2 ? "s" : ""
              })`;
            }
          } else if (error.response.data?.message) {
            errorMessage = error.response.data.message;
          } else {
            errorMessage = "Validation error. Please check your input.";
          }
        } else if (error.response.data?.data?.reason) {
          errorMessage = error.response.data.data.reason;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.status === 401) {
          errorMessage = "Current password is incorrect.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection.";
      } else {
        errorMessage = error.message || "An unexpected error occurred";
      }

      return {
        status: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async updateProfile(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/update/profile`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Profile updated successfully!",
        data: response.data,
      };
    } catch (error) {
      let errorMessage = "An error occurred while updating profile";

      if (error.response) {
        if (error.response.status === 422) {
          if (error.response.data?.errors) {
            const errorFields = Object.keys(error.response.data.errors);
            if (errorFields.length === 1) {
              errorMessage = error.response.data.errors[errorFields[0]][0];
            } else {
              errorMessage = `${
                error.response.data.errors[errorFields[0]][0]
              } (and ${errorFields.length - 1} more error${
                errorFields.length > 2 ? "s" : ""
              })`;
            }
          } else if (error.response.data?.message) {
            errorMessage = error.response.data.message;
          } else {
            errorMessage = "Validation error. Please check your input.";
          }
        } else if (error.response.data?.data?.reason) {
          errorMessage = error.response.data.data.reason;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection.";
      } else {
        errorMessage = error.message || "An unexpected error occurred";
      }

      return {
        status: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async updateNotificationPreferences(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/update/notifications`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Notification preferences updated successfully!",
        data: response.data,
      };
    } catch (error) {
      let errorMessage = "An error occurred while updating notification preferences";

      if (error.response) {
        if (error.response.status === 422) {
          if (error.response.data?.errors) {
            const errorFields = Object.keys(error.response.data.errors);
            if (errorFields.length === 1) {
              errorMessage = error.response.data.errors[errorFields[0]][0];
            } else {
              errorMessage = `${
                error.response.data.errors[errorFields[0]][0]
              } (and ${errorFields.length - 1} more error${
                errorFields.length > 2 ? "s" : ""
              })`;
            }
          } else if (error.response.data?.message) {
            errorMessage = error.response.data.message;
          } else {
            errorMessage = "Validation error. Please check your input.";
          }
        } else if (error.response.data?.data?.reason) {
          errorMessage = error.response.data.data.reason;
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection.";
      } else {
        errorMessage = error.message || "An unexpected error occurred";
      }

      return {
        status: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}

const settingsService = new SettingsService();
export default settingsService;
